define( [
	"./document"
], function( document ) {
	"use strict";

	return document.documentElement;
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/var/documentElement.js
// module id = vKSX
// module chunks = 0 1